import React from "react";

const TargetIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      {...props}
    >
      <g opacity="0.3">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.8334 5.50001C23.8334 4.48748 23.0126 3.66667 22.0001 3.66667C20.9876 3.66667 20.1667 4.48748 20.1667 5.50001V12.1C20.1667 13.1125 20.9876 13.9333 22.0001 13.9333C23.0126 13.9333 23.8334 13.1125 23.8334 12.1V5.50001ZM5.50008 20.1667C4.48756 20.1667 3.66675 20.9875 3.66675 22C3.66675 23.0125 4.48756 23.8333 5.50008 23.8333H12.1001C13.1126 23.8333 13.9334 23.0125 13.9334 22C13.9334 20.9875 13.1126 20.1667 12.1001 20.1667H5.50008ZM31.9001 20.1667C30.8876 20.1667 30.0667 20.9875 30.0667 22C30.0667 23.0125 30.8876 23.8333 31.9001 23.8333H38.5001C39.5126 23.8333 40.3334 23.0125 40.3334 22C40.3334 20.9875 39.5126 20.1667 38.5001 20.1667H31.9001ZM23.8334 31.9C23.8334 30.8875 23.0126 30.0667 22.0001 30.0667C20.9876 30.0667 20.1667 30.8875 20.1667 31.9V38.5C20.1667 39.5125 20.9876 40.3333 22.0001 40.3333C23.0126 40.3333 23.8334 39.5125 23.8334 38.5V31.9ZM8.06377 17.4167C9.51443 13.0031 13.0032 9.51435 17.4167 8.0637V10.2667V14.0597C16.0251 14.8647 14.8648 16.025 14.0597 17.4167H10.2667H8.06377ZM29.9404 17.4167C29.1354 16.025 27.975 14.8647 26.5834 14.0597V10.2667V8.0637C30.9969 9.51435 34.4857 13.0031 35.9364 17.4167H33.7334H29.9404ZM33.7334 26.5833H35.9364C34.4857 30.9969 30.9969 34.4857 26.5834 35.9363V33.7333V29.9403C27.975 29.1353 29.1354 27.975 29.9404 26.5833H33.7334ZM17.4167 33.7333V35.9363C13.0032 34.4857 9.51443 30.9969 8.06377 26.5833H10.2667H14.0597C14.8648 27.975 16.0251 29.1353 17.4167 29.9403V33.7333ZM27.5001 22C27.5001 25.0376 25.0376 27.5 22.0001 27.5C18.9625 27.5 16.5001 25.0376 16.5001 22C16.5001 18.9624 18.9625 16.5 22.0001 16.5C25.0376 16.5 27.5001 18.9624 27.5001 22Z"
          fill="#10B981"
        />
      </g>
    </svg>
  );
};

export default TargetIcon;
